module.exports = __webpack_public_path__ + "img/logo_face_verde.3a8cf1ed.svg";